module.exports = __webpack_public_path__ + "static/media/42.0d63dd7c.jpg";